export enum REFINE_ANALYTICS_EVENTS {
	SEND_QUESTIONNAIRE_LINK_TO_EMAIL = 'Customer clicked send questionnaire link to email',
	TRANSACTION_DETAILS_OPEN = 'Customer clicked transaction details',
	BEGIN_BUTTON_CLICKED = 'Customer clicked begin button',
	OPTIONAL_QUESTION_NEXT_BUTTON_CLICKED = 'Customer answered optional question',
	INVESTIGATION_COMPLETED = 'Customer completed investigation',
	WELCOME_SCREEN_LOADED = 'Customer opened context screen',
	UPLOAD_FILES_SCREEN_LOADED = 'Customer opened upload files screen',
	INVESTIGATION_COMPLETED_SCREEN_LOADED = 'Customer opened investigation completed screen',
	OPTIONAL_QUESTION_SCREEN_LOADED = 'Customer opened optional question screen',
	FIRST_QUESTION_ANSWERED = 'Customer answered first question',
	TRANSACTIONS_BREAKDOWN_OPENED = 'Customer opened transactions breakdown',
	SUBMIT_WITHOUT_DOCUMENTS_CLICKED = 'Customer clicked submit without documents',
	LANGUAGE_CHANGED = 'Customer changed language',
	FAQ_OPENED = 'Customer opened FAQ',
	PREVIOUS_BUTTON_CLICKED = 'Customer clicked previous button',
	OPEN_ANSWER_CLICKED = 'Customer clicked open answer',
	OPEN_QUESTION_OPENED = 'Customer opened open question',
	ATTACHMENT_UPLOADED = 'Customer uploaded attachment',
	GENERAL_ERROR = 'General error',
	//OUCF
	OUCF_CUSTOMER_ROTATES_SCREEN = 'Customer rotates screen',
	OUCF_CUSTOMER_ELRAGES_CHECK_IMAGE = 'Customer enlarges check image',
	OUCF_CHECK_IMAGE_LOADED = 'Check image loaded',
	OUCF_IMAGE_LOADING_ERROR = 'Check image loading error',
	OUCF_CUSTOMER_ANSWERED_YES = 'Customer answered yes',
	OUCF_CUSTOMER_ANSWERED_NO = 'Customer answered no',
	OUCF_CUSTOMER_OPENS_DEADLINE_TEXT = 'Customer opens deadline text',
	FETCH_FAILED_AFTER_RETRIES = 'Fetch failed after retries',
	SUCCESSFUL_FETCH_AFTER_RETRY = 'Successful fetch after retry',
	CTR_PAMPHLET_OPENED = 'CTR Pamphlet Opened',
}
